import {
  Box,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  MenuItem,
  Select,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import { palette } from "../../themes/theme";
import { useRef, useState } from "react";
import DarkPrimaryButton from "../PrimaryButton/DarkPrimaryButton";
import { useDispatch, useSelector } from "react-redux";
import ColorPicker from "../ColorPicker";
import HaloEffectRange from "../HaloEffectRange";
import { updatePOISetting } from "../../redux/slices/mapSettingsSlice";
import { setPoiSettings } from "../../redux/slices/mapSlice";
import { CommonUtils } from "./utilities/CommonUtils";

const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
  color: "white",
}));

export const AllPOIStyleSettings = ({
  mapRef,
  drawRef,
  setMarkers,
  markerRef,
}) => {
  const dispatch = useDispatch();
  const poiStyleSettings = useSelector((state) => state.mapSettings.poiSetting);
  const [poiStyleLocally, setPoiStyleLocally] = useState({
    poiBackgroundColor: poiStyleSettings.poiBackgroundColor,
    poiBackgroundTransparent: poiStyleSettings.poiBackgroundTransparent,
    poiWidthAndHeight: poiStyleSettings.poiWidthAndHeight,
    poiHaloEffectTransparent: poiStyleSettings.poiHaloEffectTransparent,
    poiHaloEffect: poiStyleSettings.poiHaloEffect,
    poiHaloEffect_x: poiStyleSettings.poiHaloEffect_x,
    poiHaloEffect_y: poiStyleSettings.poiHaloEffect_y,
    poiHaloEffect_b: poiStyleSettings.poiHaloEffect_b,
    poiHaloEffect_c: poiStyleSettings.poiHaloEffect_c,
    poiLeaderLineColor: poiStyleSettings.poiLeaderLineColor,
    poiLeaderLineBorderWidth: poiStyleSettings.poiLeaderLineBorderWidth,
    poiCallOut: poiStyleSettings.poiCallOut,
    showLeaderLine: poiStyleSettings.showLeaderLine,
  });
  const poiSizeRef = useRef([
    { key: "Default", value: "300px" },
    { key: "Small", value: "80px" },
    { key: "Medium", value: "100px" },
    { key: "Large", value: "120px" },
  ]);
  const poiCalloutRef = useRef([
    { key: "All Callout", value: "callout" },
    { key: "No-callout", value: "no-callout" },
    { key: "Cluster Callout", value: "cluster" },
  ]);

  const changeStyle = async (key, value) => {
    switch (key) {
      case "poiBackgroundColor-transparent":
        value = value.target.checked;
        key = "poiBackgroundTransparent";
        break;
      case "poiLeaderLineColor-transparent":
        value = value.target.checked;
        key = "showLeaderLine";
        break;
      case "logoHaloEffect-transparent":
        value = value.target.checked;
        key = "poiHaloEffectTransparent";
        break;
      default:
        break;
    }

    const tempStyle = {
      ...poiStyleLocally,
      [key]: value,
    };
    dispatch(updatePOISetting({ name: key, value }));
    for (let i = 0; i < markerRef.current.length; ++i) {
      const marker = markerRef.current[i];
      if (marker.id.startsWith("poiImage^")) {
        const markerDiv = marker.marker.getElement();
        const markerResizableContainer = markerDiv.querySelectorAll("div");
        for (let j = 0; j < markerResizableContainer.length; ++j) {
          const element = markerResizableContainer[j];
          const image = element.querySelector("img");
          if (
            image &&
            image.dataset &&
            !image.dataset.modified &&
            element.classList.contains("logo-grid-item")
          ) {
            if (key === "poiWidthAndHeight") {
              if (markerDiv && markerDiv.dataset && markerDiv.dataset.cluster) {
                //element.style.width =
                //    changedStyle.poiWidthAndHeight;
              } else {
                let width = tempStyle.poiWidthAndHeight;
                const getMeta = (url) =>
                  new Promise((resolve, reject) => {
                    const img = new Image();
                    img.onload = () => resolve(img);
                    img.onerror = (err) => reject(err);
                    img.src = url;
                  });
                await (async () => {
                  const img = await getMeta(image.src);
                  if (img.naturalWidth) {
                    if (img.naturalHeight >= img.naturalWidth - 40) {
                      switch (tempStyle.poiWidthAndHeight) {
                        case "80px":
                          width = "41px";
                          break;
                        case "100px":
                          width = "60px";
                          break;
                        case "120px":
                          width = "70px";
                          break;
                        default:
                          break;
                      }
                    }
                  }
                })();
                markerDiv.style.width = width;
              }
            }

            image.style.backgroundColor = tempStyle.poiBackgroundColor;
            if (tempStyle.poiBackgroundTransparent === true) {
              image.dataset.backgroundColor = tempStyle.poiBackgroundColor;
            } else {
              image.style.backgroundColor = "transparent";
            }
            if (
              tempStyle.poiBackgroundTransparent === false &&
              tempStyle.poiHaloEffectTransparent
            ) {
              image.style.filter = `drop-shadow(${tempStyle.poiHaloEffect_x}px ${tempStyle.poiHaloEffect_y}px ${tempStyle.poiHaloEffect_b}px ${tempStyle.poiHaloEffect})`;
              image.style.boxShadow = "unset";
            } else if (tempStyle.poiHaloEffectTransparent) {
              image.style.boxShadow = `${tempStyle.poiHaloEffect_x}px ${tempStyle.poiHaloEffect_y}px ${tempStyle.poiHaloEffect_b}px ${tempStyle.poiHaloEffect}`;
              image.style.filter = "unset";
            } else {
              image.style.boxShadow = "unset";
              image.style.filter = "unset";
              image.dataset.boxShadow = `${tempStyle.poiHaloEffect_x}px ${tempStyle.poiHaloEffect_y}px ${tempStyle.poiHaloEffect_b}px ${tempStyle.poiHaloEffect}`;
            }
            if (!tempStyle.poiHaloEffectTransparent) {
              image.dataset.logoHaloEffect = tempStyle.poiHaloEffect;
            }
            image.dataset.leaderLineEnabled = tempStyle.showLeaderLine
              ? "true"
              : "false";
            const feature = CommonUtils.HideOrShowLeaderLine({
              mapDraw: drawRef,
              connectedLeaderLine: image.id,
              correspondingElement: image,
              leaderLine: {
                leaderLineColor: tempStyle.poiLeaderLineColor,
                leaderLineWidth: tempStyle.poiLeaderLineBorderWidth,
              },
              condition: !tempStyle.showLeaderLine,
              map: mapRef,
            });
            if (feature && tempStyle.showLeaderLine && marker.id === image.id) {
              image.dataset.connectedLeaderLineWidth = String(
                tempStyle.poiLeaderLineBorderWidth
              );
              image.dataset.connectedLeaderLineColor =
                tempStyle.poiLeaderLineColor;
              feature.properties.vertexColor = tempStyle.poiLeaderLineColor;
              feature.properties["line-color"] = tempStyle.poiLeaderLineColor;
              if (tempStyle.poiLeaderLineBorderWidth > 0) {
                feature.properties["line-width"] =
                  tempStyle.poiLeaderLineBorderWidth * 1;
              }
              image.dataset.leaderLine = JSON.stringify(feature);
              if (tempStyle.showLeaderLine) {
                drawRef.add(feature);
                if (tempStyle.poiLeaderLineBorderWidth > 0) {
                  drawRef.setFeatureProperty(
                    marker.id,
                    "line-width",
                    tempStyle.poiLeaderLineBorderWidth
                  );
                }
                drawRef.setFeatureProperty(
                  marker.id,
                  "line-color",
                  tempStyle.poiLeaderLineColor
                );
                drawRef.add(feature);
              }
            }
          }
        }
      }
    }
    setPoiStyleLocally(tempStyle);
  };

  const handleOk = () => {
    dispatch(setPoiSettings(false));
  };

  return (
    <Box
      sx={{
        width: 300,
        height: 430,
        position: "absolute",
        zIndex: 4,
        borderRadius: 3,
        background: palette.background.dark,
        boxShadow: "1px 3px 12px black",
        p: "8px 20px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        left: 430,
        top: 300,
      }}
    >
      <Typography sx={{ color: palette.text.white, fontWeight: "bold" }}>
        POI Settings
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <Typography
          sx={{
            color: palette.text.white,
            fontSize: 15,
          }}
        >
          Background Color
        </Typography>
        <ColorPicker
          //   title={"Fill"}
          //   checked={polygonStyleRef.current.polygonColorTransparent}
          color={poiStyleLocally.poiBackgroundColor}
          checked={poiStyleLocally.poiBackgroundTransparent}
          setColor={changeStyle}
          type={"poiBackgroundColor"}
        />
        <Box sx={{ display: "flex", justifyContent: "space-between", gap: 1 }}>
          <FormControl fullWidth>
            <Select
              sx={{
                color: "white",
                py: 0,
                "& .MuiSelect-outlined": { py: "5px" },
              }}
              value={poiStyleLocally.poiWidthAndHeight}
              onChange={(e) => changeStyle("poiWidthAndHeight", e.target.value)}
            >
              {poiSizeRef.current.map((d, i) => (
                <CustomMenuItem key={i} value={d.value}>
                  {d.key}
                </CustomMenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <Select
              sx={{
                color: "white",
                py: 0,
                "& .MuiSelect-outlined": { py: "5px" },
              }}
              value={poiStyleLocally.poiCallOut}
              onChange={(e) => changeStyle("poiCallOut", e.target.value)}
              //TODO: Remove disabled when enable clustering.
              disabled={true}
            >
              {poiCalloutRef.current.map((d, i) => (
                <CustomMenuItem key={i} value={d.value}>
                  {d.key}
                </CustomMenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Divider />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <FormControlLabel
              control={
                <Checkbox
                  sx={{ p: 0 }}
                  defaultChecked={poiStyleLocally.poiHaloEffectTransparent}
                  onChange={(e) => changeStyle(`logoHaloEffect-transparent`, e)}
                />
              }
              sx={{ m: 0 }}
            />
            <Typography
              sx={{
                color: palette.text.white,
                fontSize: 15,
              }}
            >
              Halo Effect
            </Typography>
          </Box>
          <ColorPicker
            width={20}
            height={20}
            color={poiStyleLocally.poiHaloEffect}
            // checked={poiStyleLocally.isHaloEffectTransparent}
            rightAlign={true}
            noCheckbox={true}
            setColor={changeStyle}
            type={"poiHaloEffect"}
          />
        </Box>

        <HaloEffectRange
          title="B"
          type={"poiHaloEffect_b"}
          value={poiStyleLocally.poiHaloEffect_b}
          onChange={changeStyle}
          min={0}
          max={10}
          disabled={!poiStyleLocally.poiHaloEffectTransparent}
        />

        <HaloEffectRange
          title="X"
          type={"poiHaloEffect_x"}
          value={poiStyleLocally.poiHaloEffect_x}
          onChange={changeStyle}
          min={-20}
          max={20}
          disabled={!poiStyleLocally.poiHaloEffectTransparent}
        />

        <HaloEffectRange
          title="Y"
          type={"poiHaloEffect_y"}
          value={poiStyleLocally.poiHaloEffect_y}
          onChange={changeStyle}
          min={-20}
          max={20}
          disabled={!poiStyleLocally.poiHaloEffectTransparent}
        />

        <Divider />
        <Typography
          sx={{
            color: palette.text.white,
            fontSize: 15,
          }}
        >
          Leader Line
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          <ColorPicker
            // title={"Border"}
            // checked={polygonStyleRef.current.polygonBorderColorTransparent}
            // color={polygonStyleRef.current.polygonBorderColor}
            checked={poiStyleLocally.showLeaderLine}
            color={poiStyleLocally.poiLeaderLineColor}
            setColor={changeStyle}
            type={"poiLeaderLineColor"}
          />
          <TextField
            type="number"
            sx={{ width: "65px" }}
            label="Width"
            defaultValue={poiStyleLocally.poiLeaderLineBorderWidth}
            onChange={(e) =>
              changeStyle("poiLeaderLineBorderWidth", e.target.value)
            }
          />
        </Box>
      </Box>
      <Box>
        <DarkPrimaryButton onClick={handleOk}>Ok</DarkPrimaryButton>
      </Box>
    </Box>
  );
};
